<vex-page-layout mode="card">

    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.container]="layoutCtrl.value === 'boxed'"
             [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
             class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Monedas</h1>
                <vex-breadcrumbs
                    [crumbs]="['MENUS.ADMINISTRACION', 'Monedas']"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
        <div>
            <form [formGroup]="searchForm">
                <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                    <div
                        class="bg-foreground rounded-full px-4 h-10 max-w-[400px] flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                        <input formControlName="name"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               placeholder="Buscar monedas..."
                               type="search">
                    </div>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        matTooltip="Buscar"
                        type="button"
                        (click)="buscar()">
                        <mat-icon svgIcon="mat:search"></mat-icon>
                    </button>

                    <span class="flex-1"></span>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        matTooltip="Agregar Moneda"
                        (click)="createCurrency()"
                        type="button">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                    </button>
                </div>
            </form>

            <table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
                <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
                    <ng-container *ngIf="column.type === 'text'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ column.label | translate }}
                        </th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
                            {{ row[column.property] }}
                        </td>
                    </ng-container>
                    <ng-container *ngIf="column.type === 'image'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ column.label | translate }}
                        </th>
                        <td *matCellDef="let row" mat-cell>
                            <mat-icon *ngIf="row.active" svgIcon="mat:check" class="text-green-600"></mat-icon>
                            <mat-icon *ngIf="!row.active" svgIcon="mat:clear" class="text-red-600"></mat-icon>
                        </td>
                    </ng-container>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>{{ "GRIDS.ACCIONES" | translate }}</th>
                    <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                        <button (click)="$event.stopPropagation()"
                                [matMenuTriggerData]="{ currency: row }"
                                [matMenuTriggerFor]="actionsMenu"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns;" @fadeInUp
                    class="hover:bg-hover trans-ease-out cursor-pointer"
                    mat-row></tr>
            </table>

            <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" (page)="pageChanged($event)"
                           class="sticky left-0"></mat-paginator>
        </div>
    </vex-page-layout-content>
</vex-page-layout>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-currency="currency" matMenuContent>
        <button (click)="updateCurrency(currency)" mat-menu-item>
            <mat-icon svgIcon="mat:edit"></mat-icon>
            <span>{{ "ACTIONS.EDITAR" | translate }}</span>
        </button>
        <button (click)="deleteCurrency(currency)" mat-menu-item>
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>{{ "ACTIONS.ELIMINAR" | translate }}</span>
        </button>
    </ng-template>
</mat-menu>

